import { render, staticRenderFns } from "./ExportTestPaper.vue?vue&type=template&id=10900ef7&"
import script from "./ExportTestPaper.vue?vue&type=script&lang=js&"
export * from "./ExportTestPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10900ef7')) {
      api.createRecord('10900ef7', component.options)
    } else {
      api.reload('10900ef7', component.options)
    }
    module.hot.accept("./ExportTestPaper.vue?vue&type=template&id=10900ef7&", function () {
      api.rerender('10900ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/ExportTestPaper.vue"
export default component.exports